import { render, staticRenderFns } from "./r-modal-window.vue?vue&type=template&id=b3ba23aa&scoped=true"
import script from "./r-modal-window.vue?vue&type=script&lang=js"
export * from "./r-modal-window.vue?vue&type=script&lang=js"
import style0 from "./r-modal-window.vue?vue&type=style&index=0&id=b3ba23aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ba23aa",
  null
  
)

export default component.exports